export const routes = {
  INSTANT_QUOTE: '/',
  TRANSLATION_QUOTE: {
    ROOT: '/translationquote',
    FORM: '/translationquote/page1',
    PRICING: '/translationquote/page2',
    THANK_YOU: '/translationquote/thankyou',
  },
  NEED_IT_SOONER: '/needitsooner',
  THANK_YOU: '/thankyou',
  INTERPRETING_QUOTE: '/interpretingquote',
  PROOFREADING_QUOTE: '/proofreadingquote',
  MULTILINGUALDTP_QUOTE: '/multilingualdtpquote',
  AUDIO_TRANSCRIPTION_QUOTE: '/audiotranscriptionquote',
  COPYWRITING_QUOTE: '/copywritingquote',
  SUBTITLING_QUOTE: '/subtitlingquote',
  PAYMENT: '/payments',
  PAYMENT_FINALIZATION: '/finalization/payments',
  TRANSACTION_STATUS: '/transactionstatus',
  VOICE_OVER_QUOTE: '/voiceoverquote',
  AUTOMATED_QUOTE_GENERATION: '/automatedgeneration',
  INVOICE_PORTAL: {
    ROOT: '/invoicePortal',
    LOGIN: '/invoicePortal/login',
    ORDERS: '/invoicePortal/orders',
    STATUS: '/invoicePortal/status',
  },
  PAYMENT_3DS_FINALIZATION: '/3dsfinalization',
};

export const appPaths = [
  `*${routes.THANK_YOU}/:id`,
  `*${routes.NEED_IT_SOONER}/:id`,
  `*${routes.AUTOMATED_QUOTE_GENERATION}/:id`,
  `${routes.TRANSACTION_STATUS}/:transactionId`,
  routes.PROOFREADING_QUOTE,
  routes.COPYWRITING_QUOTE,
  routes.SUBTITLING_QUOTE,
  routes.VOICE_OVER_QUOTE,
  routes.INTERPRETING_QUOTE,
  routes.MULTILINGUALDTP_QUOTE,
  routes.AUDIO_TRANSCRIPTION_QUOTE,
  routes.TRANSLATION_QUOTE.ROOT,
  routes.INVOICE_PORTAL.ROOT,
];
